/*
  Grid position of a clicked product card on a collection page, for the merch measurement
  (merch/SPEC.md section 11). The custom pixel in Customer events runs sandboxed and cannot
  read the page, so the click is published here as a custom event and the pixel subscribes to
  it and sends select_item to GA4.

  The position is the one the card carries, counted from 0 across pages, pins included and the
  editorial tile not counted. Fires once per click, before the browser follows the link.
*/
(() => {
  const EVENT = 'rubato:select_item';
  document.addEventListener(
    'click',
    (event) => {
      const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
      const item = link?.closest('.product-grid__item[data-position][data-collection]');
      if (!item) return;
      const publish = window.Shopify?.analytics?.publish;
      if (typeof publish !== 'function') return;
      try {
        publish(EVENT, {
          item_list_id: item.dataset.collection,
          item_id: item.dataset.productId,
          index: Number(item.dataset.position),
        });
      } catch {
        // Measurement never gets in the way of the click.
      }
    },
    { capture: true }
  );
})();
